<template>
  <div class="page-header">
    <span>{{ name }}</span>
    <el-icon v-if="setting" style="cursor: pointer" size="18" @click="$emit('change-name')"><Edit /></el-icon>
  </div>
</template>

<script setup>
defineProps({ name: String, setting: Boolean })
defineEmits(['change-name'])
</script>

<style lang="scss" scoped>
.page-header {
  width: 100%;
  height: 80px;
  background-position: center;
  background-size: cover;
  background-image: url('@/assets/dashboard/header.png');
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  font-size: 2em;
  font-weight: bold;
  text-shadow: 2px 2px 6px rgba(255, 255, 255, 0.5);
}
</style>
